import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import {
  HeaderRoot,
  HeaderTitle,
  HeaderUpButton,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { CancelAssistProUpsertPublicPhoneFormComponent } from "@/components/assist/cancel-assist-pro-upsert-public-phone";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";

import type { JSX } from "react";

const UpsertPhonePageQuery = graphql(/* GraphQL */ `
  query UpsertPhonePageQuery {
    ...UpsertPublicPhoneAssistFragment
  }
`);

const UpsertPhonePage = (): JSX.Element => {
  const queryResult = useGraphQL(UpsertPhonePageQuery, {});
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="Cancelamento" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? <CancelAssistProUpsertPublicPhoneFormComponent data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/assist/unsubscribe-assist-pro/upsert-phone/",
)({
  component: UpsertPhonePage,
});
